import { EntityStoreState } from 'common/models/data/entityStore.model';

const initialEntityState: EntityStoreState = {
    entityDetails: {},
    categoryDetails: {},
    indicatorDetails: {},
    sources: {}
};

export default initialEntityState;
